module.exports = __webpack_public_path__ + "static/img/in-depth-bible-study.bf2b5dc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ministries/in-depth-bible-study.jpg
// module id = tSOr
// module chunks = 1